import { combineReducers } from 'redux'
import globalMessagingReducer from 'utils/reducers/globalMessaging'
import carriersReducer from 'apps/fleet-planner/utils/reducers/carriers'
import customersReducer from 'apps/fleet-planner/utils/reducers/customers'
import dispatchersReducer from 'apps/fleet-planner/utils/reducers/dispatchers'
import { createDriverReducer } from 'apps/fleet-planner/utils/reducers/driver'
import driversReducer from 'apps/fleet-planner/utils/reducers/drivers'
import { equipmentReducer } from 'apps/fleet-planner/utils/reducers/equipment'
import { recentFacilitiesReducer } from 'apps/fleet-planner/utils/reducers/facilities'
import loadCountsReducer from 'apps/fleet-planner/utils/reducers/loadCounts'
import loadDetailsReducer from 'apps/fleet-planner/utils/reducers/loadDetails'
import loadsReducer from 'apps/fleet-planner/utils/reducers/loads'
import modalsReducer from 'apps/fleet-planner/utils/reducers/modals'
import { createTrailerReducer } from 'apps/fleet-planner/utils/reducers/trailer'
import { createTruckReducer } from 'apps/fleet-planner/utils/reducers/truck'
import { IStore } from '../types/store'

const reducers = combineReducers<IStore>({
  globalMessaging: globalMessagingReducer,
  loads: loadsReducer,
  loadCounts: loadCountsReducer,
  carriers: carriersReducer,
  drivers: driversReducer,
  dispatchers: dispatchersReducer,
  modals: modalsReducer,
  loadDetails: loadDetailsReducer,
  equipment: equipmentReducer,
  driver: createDriverReducer,
  customers: customersReducer,
  trailer: createTrailerReducer,
  truck: createTruckReducer,
  facilities: recentFacilitiesReducer,
})

export default reducers
